/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { CloseOutlined } from '@mui/icons-material';
import { Avatar, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { LanguageContext } from '../../../libs/Context';
import MainCard from '../../../UiComponents/Cards/MainCard';
import Loading from '../Loaders/FullWidthLoader/Loading';
import useDebounce from '../../Hooks/useDebounce';
import NoData from '../NoData';
import Meetings from '../../../assets/NoDataImages/NoMeetings.svg';

const FeedAvatarList = (props) =>
{
	const { handleAttendeesClose, openPopUp, requestType, getFeedData } = props;
	const taggedUserRef = useRef<any>(getFeedData?.employees ?? getFeedData?.taggedPeople ?? []);
	const { language } = useContext(LanguageContext);
	const [ searchVal, setSearchVal ] = useState<string>('');
	const lastEleRef = useRef<HTMLSpanElement>(null);
	const [ attendesList, setAttendesList ] = useState<any>({
		// count        : 0,
		// pageSkip     : 0,
		// itemsPerPage : 10,
		userList : taggedUserRef.current?.length > 0 ? taggedUserRef.current : [],
		loading  : !(taggedUserRef.current?.length > 0)
		// scrollLoading : false
	});
	const { userList, loading } = attendesList;
	const baseUrl = process.env.REACT_APP_S3_BASE_URL;
	// Keep a copy of the original list
	const originalUserList = useRef(taggedUserRef.current || []);
	const debouncedSearchTerm = useDebounce(searchVal, 500);

	// Update userList based on search term
	const updateUserList = (searchTerm) =>
	{
		setAttendesList((prev) =>
		{
			let updatedUserList;

			if (searchTerm)
			{
				updatedUserList = originalUserList.current.filter((user) =>
					user.name.toLowerCase().includes(searchTerm.toLowerCase())
				);
			}
			else
			{
				updatedUserList = originalUserList.current;
			}

			return {
				...prev,
				userList : updatedUserList
			};
		});
	};

	// Trigger user list update whenever debounced search term changes
	useEffect(() =>
	{
		updateUserList(debouncedSearchTerm);
	}, [ debouncedSearchTerm ]);

	return (
		<Dialog open={openPopUp} fullWidth maxWidth={'sm'}>
			<DialogTitle>
				<Grid container>
					<Grid item xs={12}>
						<Stack
							direction='row'
							justifyContent='space-between'
							alignItems='center'
						>
							<Typography variant='h6'>
								{props?.title ? props?.title : language?.attendees}
								<Typography variant='subtitle1' component={'span'} pl='var(--pixel8)'>({userList?.length})</Typography>
							</Typography>
							<IconButton onClick={handleAttendeesClose}>
								<CloseOutlined sx={{ cursor: 'pointer' }} />
							</IconButton>
						</Stack>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container direction={'column'}>
					<Grid item>
						<TextField
							size='small'
							variant='outlined'
							placeholder={language?.searchMembers}
							fullWidth
							value={searchVal}
							disabled={searchVal === '' && userList?.length === 0}
							onChange={(e) => setSearchVal(e.target.value.replace(/^\s+/, ''))}
							InputProps={{
								startAdornment : (
									<InputAdornment position='start'>
										<SearchIcon />
									</InputAdornment>
								)
							}}
						/>
					</Grid>
					<Grid item mt={1}>
						<MainCard>
							<Grid item sx={{ maxHeight: '300px', overflowY: 'auto' }} display={'flex'} flexDirection={'column'}>
								{loading && <Loading />}
								{userList?.length > 0 && userList?.map((each, index) => (
									<Stack key={index} direction='row' spacing={1} mb={1}>
										<Avatar
											src={each?.userId ? `${baseUrl}/profile/${each?.userId}_profile.jpeg` : '/images/icons/defaultUser.svg'}
											sx={{ width: '38px', height: '38px' }}
										/>
										{requestType === 'occasion' &&
											<Stack display={'flex'} flexDirection={'column'} pl='var(--pixel8)'>
												<Typography>{each?.name ?? 'NA'}</Typography>
											</Stack>
										}
										{index === (userList.length - 2) && <span ref={lastEleRef} />}
									</Stack>
								))}
								{!loading && userList?.length === 0 &&
								<NoData noDataHead={'No Attendees Found'} color='lightTxt'
									src={<img src={Meetings} />}
								/>}
							</Grid>
						</MainCard>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default FeedAvatarList;
